import { atomWithReset } from 'jotai/utils';

/**
 * @desc Atom of a conversation
 */
export const atomConversation = atomWithReset<number | null>(null);
atomConversation.debugLabel = 'atomConversation';
